import { render, staticRenderFns } from "./BottomFloatingFrame.vue?vue&type=template&id=6daef0b7&scoped=true&"
import script from "./BottomFloatingFrame.vue?vue&type=script&lang=ts&"
export * from "./BottomFloatingFrame.vue?vue&type=script&lang=ts&"
import style0 from "./BottomFloatingFrame.vue?vue&type=style&index=0&id=6daef0b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daef0b7",
  null
  
)

export default component.exports